import { render, staticRenderFns } from "./Inflections.vue?vue&type=template&id=34142669&scoped=true&"
import script from "./Inflections.vue?vue&type=script&lang=js&"
export * from "./Inflections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34142669",
  null
  
)

export default component.exports